module.exports = __webpack_public_path__ + "fonts/HKNova-Regular.8e87bfef.woff2";